export default __webpack_public_path__ + "static/media/Groupe 276.2c980788.svg";